/**
 * BarcodeSearch component allows users to search for returns receipts by entering a barcode.
 *
 * @component
 * @example
 * return (
 *   <BarcodeSearch />
 * )
 *
 * @returns {JSX.Element} The BarcodeSearch component.
 *
 * @description
 * This component renders a form with an input field for entering a barcode and a search button.
 * When the form is submitted, it dispatches an action to get the returns receipt associated with the entered barcode
 * and navigates to the returns page. If the user is not logged in, they are redirected to the login page.
 *
 * @requires useNavigate from 'react-router-dom'
 * @requires useDispatch from 'react-redux'
 * @requires Container, Form, Button from 'react-bootstrap'
 * @requires getreturnsReceipt from '../actions/posActions'
 */
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Container, Form, Button } from 'react-bootstrap'
import { getreturnsReceipt } from '../actions/posActions'

let cid

const BarcodeSearch = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [barcode, setBarcode] = useState('')

  // Userinfo get cid
  const userInfo = JSON.parse(localStorage.getItem('userInfo'))

  if (userInfo) {
    cid = userInfo.cid
  }
  // Redirect to login if not logged in
  useEffect(() => {
    if (!userInfo) {
      navigate('/login')
    }
  }, [userInfo, navigate])

  // Reset returns state if no barcode
  useEffect(() => {
    if (barcode === '' || barcode === undefined) {
      dispatch({ type: 'RETURNS_RESET' })
    }
  }, [dispatch, barcode])

  // Handle search
  const handleSearch = (e) => {
    e.preventDefault()
    dispatch(getreturnsReceipt(barcode, cid))
    navigate(`/returns`)
  }

  // Render
  return (
    <Container>
      <Form onSubmit={handleSearch}>
        <input
          autoFocus
          type='text'
          name='barcode'
          placeholder='Enter barcode'
          value={barcode}
          style={{ width: '50%' }}
          onChange={(e) => setBarcode(e.target.value)}
          className='form-control ml-sm-2 my-2'
        />
        <Button type='submit' className='my-1'>
          Search
        </Button>
      </Form>
    </Container>
  )
}

export default BarcodeSearch
